import { IGetAllReajusteUseCase } from "../../../presentation/useCases/read/get_all_reajuste_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { Reajuste } from "../../models/reajuste";

/**
 * GetAllReajusteUseCase
 */

export class GetAllReajusteUseCase extends BasePaginatedUseCase<Reajuste> implements IGetAllReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllReajuste(
    idIndiceReajuste: number,
    page?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const response = await this.repository.getAllReajusteLista(
      idIndiceReajuste,
      page,
      rowsPerPage
    );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
